import { Thead, Tr, Th } from '@patternfly/react-table'
import * as React from 'react'
import { useCallback } from 'react'

import type { ISorting } from '@app/lib/sorting'

interface Props {
  sorting: ISorting
  columnNames: { title: string; value: string; sortable?: boolean }[]
}

export const ConfiguredInteractionsTableHeader = ({
  sorting,
  columnNames,
}: Props) => {
  const { onSetSort, sortField, sortDirection } = sorting

  const onSort = useCallback(
    (_event, index, direction) => {
      const fieldName = columnNames[index].value
      onSetSort(fieldName, direction)
    },
    [onSetSort, columnNames],
  )

  const sortIndex = columnNames.findIndex((it) => it.value === sortField)

  return (
    <Thead noWrap>
      <Tr>
        {columnNames.map((column, columnIndex) => {
          const isSortable = column.sortable !== false
          const sortParams = isSortable
            ? {
                sort: {
                  sortBy: {
                    index: sortIndex,
                    direction: sortDirection,
                  },
                  onSort,
                  columnIndex,
                },
              }
            : undefined

          return (
            <Th key={columnIndex} {...sortParams}>
              {column.title}
            </Th>
          )
        })}
      </Tr>
    </Thead>
  )
}
